export default {
  createPost: "/posts/upload",
  getPosts: "/posts/getAllPostsForAUser",
  deletePost: "/posts/delete",
  getSignedUrl: "/spaces/presigned_url",
  createComment: "/posts/createComment"
};
